import React from 'react';

const VisualiserTitreDetention = () => {
    return <div>Visualiser un titre de detention TODO</div>;
};

export default VisualiserTitreDetention;
